// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"545":"34300cca","554":"391f331a","760":"234f6485","804":"60956353","815":"4a903754","918":"f4b2a0f4"}[chunkId] + ".chunk.js";
};